export default __webpack_public_path__ + "static/media/projects.da3d7151.svg";